<table style="width:88%;margin:0 auto">
    <tr>
        <td>
            <h1 class="em-h1" style="font-family: 'Nunito', sans-serif;font-weight:900;margin-top:40px">{{ title}}</h1>
            <div class="em-para" style="font-family: 'Nunito', sans-serif;font-weight:400;font-size:20px;line-height:30px" [innerHTML]="body"></div>
        </td>
    </tr>
</table>